import React from 'react';
import './rounded-switch.scss';

interface RoundedSwitchProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    label: string;
}

const RoundedSwitch: React.FC<RoundedSwitchProps> = ({ checked, onChange, label }) => {
    return (
        <label className="switch is-rounded">
            <input type="checkbox" checked={checked} onChange={onChange} />
            <span className="check" />
            <span className="control-label">{label}</span>
        </label>
    );
};

export default RoundedSwitch;